import React , {useState} from 'react'
import "./searchItems.css"
import {FaSearchengin} from "react-icons/fa";
import SearchItemPage from './SearchItemPage';

const SearchItemsContainer = () => {
  
    const [showSearch, setShowSearch] = useState(false);

  return (
    <>
      <div className='food-search-container' onClick={() => setShowSearch(true) }>
          <span><FaSearchengin/></span>
          <p>search for dishes</p>
      </div>
      <SearchItemPage showSearch={showSearch} setShowSearch={setShowSearch}  />
    </>
  )
}

export default SearchItemsContainer